
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-0c5cc82e&scoped=true!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ActivityManager.vue")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ActivityManager.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-0c5cc82e!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ActivityManager.vue"),
  /* scopeId */
  "data-v-0c5cc82e",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/views/activity/ActivityManager.vue
// module id = 977
// module chunks = 2